export default function getStatusColor(status: 'processing' | 'active' | 'inactive') {
    switch(status) {
        case 'processing':
            return '#FEB344';
        case 'active':
            return '#1BCC62';
        case 'inactive':
            return '#FF9993';
    }
}